import Header from '../header/Header';

function Layout({ children }) {
  return (
    <>
      <div className={"px-8"}>
        <Header />
      </div>

      <div className="container w-full mx-auto max-w-full h-full p-8">
        <div className="w-full h-full default-bg-color rounded-2xl border border-gray-100">
          {children}
        </div>
      </div>
    </>
  );
}

export default Layout;
